import sdl from '@jds/react-generated-sdl/JDSDropdownMenuSubMenuInternal';
import type { JDSDropdownMenuSubMenuInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDropdownMenuSubMenuInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDropdownMenuSubMenuInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenuSubMenuInternal = withLogic(
  Component
) as React.FC<JDSDropdownMenuSubMenuInternalProps> & { slotName?: string };

DropdownMenuSubMenuInternal.displayName = 'DropdownMenuSubMenuInternal';
DropdownMenuSubMenuInternal.slotName = 'jds_dropdown_menu_sub_menu_internal';

export {
  DropdownMenuSubMenuInternal,
  type JDSDropdownMenuSubMenuInternalProps
};
